import styled from "styled-components";

export const FooterGrid = styled.div(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "auto",
  gridGap: "40px",

  [theme.breakpoint.md()]: {
    gridTemplateColumns: "auto auto",
  },
  [theme.breakpoint.lg()]: {
    gridTemplateColumns: "auto auto auto",
    gridGap: "60px",
  },
}));

export const ContactContainer = styled.div(({ theme }) => ({
  background: theme.color.brandPrimary.medium,
  padding: "34px 20px",
  display: "flex",
  flexDirection: "column",
  gap: 32,

  [theme.breakpoint.lg()]: {
    padding: "34px 112px",
  },
}));

export const FooterTitle = styled.h1(({ theme }) => ({
  color: theme.color.neutral["08"],
  fontSize: "24px",
  lineHeight: "36px",

  [theme.breakpoint.lg()]: {
    fontSize: "28px",
    lineHeight: "42px",
  },
}));

export const FooterItem = styled.div(({ theme, noFooter }) => ({
  color: noFooter ? theme.color.brandPrimary.light : theme.color.neutral["08"],
  width: "100%",
}));

export const FooterItemDescription = styled.p(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "21px",

  [theme.breakpoint.lg()]: {
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

export const FooterItemLink = styled.a(({ theme }) => ({
  fontWeight: 500,
  fontSize: "18px",

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));

export const FooterHeader = styled.div(() => ({
  marginBottom: "12px",
  display: "flex",
  gap: "20px",
}));

export const Divider = styled.div(({ theme }) => ({
  border: `1px solid ${theme.color.line.medium}`,
  width: "100%",
}));

export const ReclameAquiStamps = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",

  [theme.breakpoint.md()]: {
    height: 0,
    justifyContent: "end",
    alignItems: "end",
  },
}));

export const AboutContainer = styled.div(({ theme }) => ({
  padding: "40px 20px",
  display: "flex",
  flexDirection: "column",
  gap: 32,
  background: theme.color.neutral["08"],

  [theme.breakpoint.lg()]: {
    padding: "44px 112px",
  },
}));

export const AboutLink = styled.a(({ theme }) => ({
  color: theme.color.neutral["03"],
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "24px",
  textDecoration: "underline",
  cursor: "pointer",

  [theme.breakpoint.lg()]: {
    fontSize: "18px",
    lineHeight: "27px",
  },
}));

export const NavLinkAbout = styled.nav(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 16,

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    gap: 40,
  },
}));

export const AboutDescription = styled.span(({ theme }) => ({
  color: theme.color.neutral["03"],
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "18px",

  [theme.breakpoint.lg()]: {
    fontSize: "14px",
    lineHeight: "21px",
  },
}));

export const AboutDescriptionContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 32,

  "span:nth-child(even)": {
    textAlign: "right",
  },

  [theme.breakpoint.md()]: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "end",
  },
}));
